import React from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import './App.css';
import 'font-awesome/css/font-awesome.min.css';
import { createBrowserHistory as createHistory } from 'history';

// import { createBrowserHistory as createHistory } from 'history';
import AsyncComponent from './AsyncComponent';

const LandingPage = AsyncComponent(() =>
  import('./Pages/LandingPage/landingpage').then(module => module.default)
  // import('./Pages/Comparator/comparator').then(module => module.default)
)

const issuedetailspage = AsyncComponent(() =>
  import('./Pages/Issuedetails/Issuedetailspage').then(module => module.default)
)
const loginpage = AsyncComponent(() =>
  import('./Pages/Login/login').then(module => module.default)
)
const rawdatapage = AsyncComponent(() =>
  import('./Pages/RawdataDownload/rawdata').then(module => module.default)
)
const comparatorpage = AsyncComponent(() =>
  import('./Pages/traceComparator/traceComparator').then(module => module.default)
)
const rtdashboard = AsyncComponent(() =>
  import('./Pages/TableauDashboard/tableauview').then(module => module.default)
)
const dmdashboard = AsyncComponent(() =>
  import('./Pages/TableauDashboard/dmdasboard').then(module => module.default)
)
const stashcnt = AsyncComponent(() =>
  import('./Pages/Stash/stashcnt').then(module => module.default)
)
const admctrl = AsyncComponent(() =>
  import('./Pages/adm/admctrl').then(module => module.default)
)
const selectctrl = AsyncComponent(() =>
  import('./Pages/dummy/dumy').then(module => module.default)
)
const vuectrl = AsyncComponent(() =>
  import('./Pages/TableauDashboard/vuedash').then(module => module.default)
)
const reportctrl = AsyncComponent(() =>
  import('./Pages/reports/reportspage').then(module => module.default)
)
const trendsctrl = AsyncComponent(() =>
  import('./Pages/trends/trends').then(module => module.default)
)
const trendcompctrl = AsyncComponent(() =>
  import('./Pages/TrendComparator/trendcomparator').then(module => module.default)
)




const history = createHistory();
class App extends React.Component { 
  constructor(props, context) {
    super(props, context);
    this.state = {
      reload: ''
    }
    
    sessionStorage.reload = true;
    
  }
  render() {
    if(history.location.pathname === '/'){
      sessionStorage.reload = "";
      console.clear();
    }else if (sessionStorage.reload && history.location.pathname !== '/' ) {
      sessionStorage.reload = "";
      console.clear();
      history.push('/');
    }else{
      console.clear();
      sessionStorage.reload = "";
    }
    return (
      <Router history={history}>
      <div className="App">
        <Switch>
        <Route path="/" exact strict component={ loginpage } />
          <Route path="/Dashboard" exact strict component={ LandingPage } />
          <Route path="/issuedetails" exact strict component={ issuedetailspage } />
          <Route path="/rawdata" exact strict component={ rawdatapage } />
          <Route path="/comparator" exact strict component={ comparatorpage } />
          <Route path="/RTD" exact strict component={ rtdashboard } />
          <Route path="/DM" exact strict component={ dmdashboard } />
          <Route path="/ticket" exact strict component={ stashcnt } />
          <Route path="/adm" exact strict component={ admctrl } />
          <Route path="/selectall" exact strict component={ selectctrl } />
          <Route path="/vuedashboard" exact strict component={ vuectrl } />
           <Route path="/trends" exact strict component={ trendsctrl } />
          <Route path="/reports" exact strict component={ reportctrl } />
          <Route path="/trendcomparator" exact strict component={ trendcompctrl } />
        </Switch>
      </div>
      </Router>
    );
  }
}

export default App;
